module.exports = __webpack_public_path__ + "img/japan.b2ee3002.svg";